export default __webpack_public_path__ + "static/media/registerCircle.1ddc634e.svg";